import { QueryTypeProps } from '../../../query-type';
import { RelatedQuestionsProps } from '../../../related-questions';
import { URLS } from '../../../../../../models/url/constants';
import changeCoverImage from './images/change-cover.svg';
import healthInsuranceImage from './images/health-insurance.svg';
import hospitalImage from './images/hospital.svg';

export type OptionData = Readonly<{
  queryType: QueryTypeProps;
  relatedQuestions: RelatedQuestionsProps;
}>;

export const extrasOptionData: OptionData = {
  queryType: {
    image: {
      src: healthInsuranceImage.src,
    },
    links: [
      {
        name: 'Make an extras claim',
        url: URLS.MEMBERS.CLAIMS,
      },
      {
        name: 'Check your limits or waiting periods',
        url: URLS.MEMBERS.YOUR_COVER,
      },
      {
        name: 'Find a provider',
        url: URLS.MEMBERS.FIND_A_PROVIDER,
      },
    ],
    title: 'Extras',
  },
  relatedQuestions: {
    links: [
      {
        name: 'What can I get back on my extras claim?',
        url: URLS.HELP.HOW_MUCH_WILL_I_GET_BACK_ON_MY_EXTRAS_CLAIM,
      },
      {
        name: 'How do I make an extras claim online?',
        url: URLS.HELP.MAKE_AN_EXTRA_CLAIM,
      },
      {
        name: 'Dental cover explained',
        url: URLS.SALES.EXPLAINED_DENTAL_AND_ORTHODONTICS,
      },
      {
        name: 'How does extras cover work?',
        url: URLS.HELP.HOW_DOES_EXTRA_COVER_WORK,
      },
    ],
  },
};

export const hospitalOptionData: OptionData = {
  queryType: {
    image: {
      src: hospitalImage.src,
    },
    links: [
      {
        name: 'My cover overview',
        url: URLS.MEMBERS.YOUR_COVER,
      },
      {
        name: 'Hospital cover check',
        url: URLS.MEMBERS.HOSPITAL_COVER_CHECK,
      },
      {
        name: 'Hospital and ambulance claims',
        url: URLS.MEMBERS.CLAIMS,
      },
    ],
    scrollTo: 'Hospital',
    title: 'Hospital',
  },
  relatedQuestions: {
    links: [
      {
        name: 'Going to hospital guide',
        url: URLS.HELP.GOING_TO_HOSPITAL_GUIDE,
      },
      {
        name: 'Getting the most out of hospital cover',
        url: URLS.SALES.EXPLAINED_GETTING_THE_MOST_OUT_OF_PRIVATE_HOSPITAL_COVER,
      },
      {
        name: 'What’s a partner hospital or day surgery?',
        url: URLS.HELP.PARTNER_HOSPITAL,
      },
      {
        name: 'How do I make an ambulance claim?',
        url: URLS.HELP.HOW_DO_I_MAKE_AN_AMBULANCE_CLAIM,
      },
    ],
  },
};

export const myAccountOptionData: OptionData = {
  queryType: {
    image: {
      src: healthInsuranceImage.src,
    },
    links: [
      {
        name: 'Manage payments',
        url: URLS.MEMBERS.PAYMENTS,
      },
      {
        name: 'Update my personal details',
        url: URLS.MEMBERS.SETTINGS,
      },
      {
        name: 'Update income tier',
        url: URLS.MEMBERS.UPDATE_AGR,
      },
    ],
    title: 'My account',
  },
  relatedQuestions: {
    links: [
      {
        name: 'How can I pay my premiums?',
        url: URLS.HELP.HOW_CAN_I_PAY_MY_PREMIUMS,
      },
      {
        name: 'How do I set up or change direct debit?',
        url: URLS.HELP.DIRECT_DEBIT_DETAILS_SETUP_OR_UPDATE,
      },
      {
        name: 'How do I change my payment frequency or date?',
        url: URLS.HELP.HOW_DO_I_CHANGE_MY_PAYMENT_FREQUENCY,
      },
      {
        name: 'How do I update my contact details?',
        url: URLS.HELP.HOW_DO_I_UPDATE_MY_CONTACT_DETAILS,
      },
    ],
  },
};

export const changeCoverOptionData: OptionData = {
  queryType: {
    image: {
      src: changeCoverImage.src,
    },
    links: [
      {
        name: 'Change cover online',
        url: URLS.MEMBERS.CHANGE_YOUR_COVER,
      },
      {
        name: 'My cover overview',
        url: URLS.MEMBERS.YOUR_COVER,
      },
      {
        name: 'Check what I’m covered for',
        url: `${URLS.MEMBERS.DOCUMENTS}?type=product-guides`,
      },
    ],
    title: 'Change cover',
  },
  relatedQuestions: {
    links: [
      {
        name: 'How do I change my cover?',
        url: URLS.HELP.HOW_DO_I_CHANGE_MY_COVER,
      },
      {
        name: 'Why switch cover?',
        url: URLS.SALES.EXPLAINED_SWITCHING,
      },
      {
        name: 'Adding or removing people',
        url: URLS.HELP.ADDING_OR_REMOVING_PEOPLE,
      },
      {
        name: 'What’s my excess?',
        url: URLS.HELP.WHAT_IS_EXCESS,
      },
    ],
  },
};

export const somethingElseOptionData: OptionData = {
  queryType: {
    image: {
      src: healthInsuranceImage.src,
    },
    links: [
      {
        name: 'Request a new card',
        url: URLS.MEMBERS.REPLACEMENT_CARD,
      },
      {
        name: 'Check my product guide',
        url: `${URLS.MEMBERS.DOCUMENTS}?type=product-guides`,
      },
      {
        name: 'Submit a form or document',
        url: URLS.MEMBERS.DOCUMENTS,
      },
    ],
    title: 'Something else',
  },
  relatedQuestions: {
    links: [
      {
        name: 'Tax FAQ’s',
        url: URLS.HELP.TAX_FAQS,
      },
      {
        name: 'How do I make an ambulance claim?',
        url: URLS.HELP.HOW_DO_I_MAKE_AN_AMBULANCE_CLAIM,
      },
      {
        name: 'Use digital card for Android',
        url: URLS.HELP.DIGITAL_CARD_ANDROID,
      },
      {
        name: 'Using digital card for iPhone',
        url: URLS.SALES.EXPLAINED_APPLE_CARD,
      },
    ],
  },
};
